import { useMemo } from "react";
import { Tooltip, TooltipContent, TooltipTrigger } from "../ui/tooltip";

export const OnlineStatusIndicator = ({ lastOnlineTime }: { lastOnlineTime: string | null }) => {
  const { isValid, title, dotClass, isOnline } = useMemo(() => {
    if (!lastOnlineTime) return { isValid: false, title: "", dotClass: "", isOnline: false };

    const parsedDate = new Date(lastOnlineTime);
    if (Number.isNaN(parsedDate.getTime())) {
      return { isValid: false, title: "", dotClass: "", isOnline: false };
    }

    const diffMs = Math.max(0, Date.now() - parsedDate.getTime());
    const totalMinutes = Math.floor(diffMs / 60000);
    const hours = Math.floor(totalMinutes / 60);
    const minutes = totalMinutes % 60;
    const days = Math.floor(totalMinutes / (60 * 24));
    const isOnlineNow = totalMinutes < 15;

    let lastOnlineLabel: string;
    if (isOnlineNow) lastOnlineLabel = "now";
    else if (days >= 1) lastOnlineLabel = `${days} day${days > 1 ? "s" : ""} ago`;
    else if (hours >= 1) lastOnlineLabel = `${hours}h ${minutes}m ago`;
    else lastOnlineLabel = `${minutes}m ago`;

    const indicatorClass = isOnlineNow ? "bg-emerald-600" : "bg-slate-300";

    return {
      isValid: true,
      title: lastOnlineLabel,
      dotClass: indicatorClass,
      isOnline: isOnlineNow,
    };
  }, [lastOnlineTime]);

  if (!isValid) return null;

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div className={`h-2 w-2 flex-shrink-0 rounded-full ${dotClass}`} />
      </TooltipTrigger>
      <TooltipContent>{isOnline ? "Online" : `Last online ${title}`}</TooltipContent>
    </Tooltip>
  );
};
